import React, { useState } from 'react';
import { addList as addToCartService } from '../../Services/Cart.service';
import withReactiveStyleBuyButton from './../withReactiveStyleBuyButton';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { translate } from "../../Services/translation";
import ProductBuyButton from "./ProductBuyButton";
import OnDemandModal from "./OnDemandModal";
import { clearErrorMessage, setMessage } from "../../Actions/ProductDetail.action";

const LogosProductBuyButton = (props) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const onClick = async (products, logo, onDemandComment) => {
        dispatch(clearErrorMessage());
        try {
            const products = props.items.map(x => ({
                ...x,
                logo: logo.name,
                logoArticleNumber: logo.articleNumber,
                alwaysAddItem: true,
				configurableVariantId: props.configurableVariantId,
				commentLabel: onDemandComment?.label,
				comment: onDemandComment?.comment,
            }));

            if (products.length > 0) {
                await addToCartService(products).then((cart) => {
                    dispatch(setMessage({
                        message: translate('product-variant.notification.logo.text', props.productName, logo.name),
                        type: 'info'
                    }));

                    dispatch(receive(cart));
                });
            }
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
        }
    };

    const Button = withReactiveStyleBuyButton(ProductBuyButton, () => setOpen(true), 'buy-button');

    return <Button {...props}>
        {
            props.logos.length > 0 && <OnDemandModal
                setOpen={setOpen}
                setClose={() => setOpen(false)}
                open={open}
                comment={props.comment}
                onClick={(logo, onDemandComment) => {
                    onClick(props.items, logo, onDemandComment);
                }}
                logos={props.logos}
            ></OnDemandModal>
        }

    </Button>
};

export default LogosProductBuyButton;
